import { render, staticRenderFns } from "./SearchResultHeader.vue?vue&type=template&id=3d18e4bc"
import script from "./SearchResultHeader.vue?vue&type=script&lang=ts"
export * from "./SearchResultHeader.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultHeader.vue?vue&type=style&index=0&id=3d18e4bc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports